import { useMemo } from 'react';

import { buildFlatGradientFromColorStops } from '../helpers/build-flat-gradient-from-color-stops';
import {
  buildLinearGradientCssString,
  buildRadialGradientCssString,
} from '../helpers/build-gradient-css-string';
import { gradientModelManager } from '../helpers/gradient-model-manager';
export function useBackground(model) {
  const { colorStops } = model;

  return useMemo(() => {
    if (colorStops.length === 0) {
      return {
        previewBackground: 'transparent',
        sliderBackground: 'transparent',
      };
    }

    const sliderBackground = buildFlatGradientFromColorStops(colorStops);
    const linearAngle = gradientModelManager.extractLinearAngle(model);
    const radialPosition = gradientModelManager.extractRadialPosition(model);
    const radialEndingShape = gradientModelManager.extractRadialEndingShape(model);

    const previewBackground =
      model.type === 'linear-gradient'
        ? buildLinearGradientCssString(linearAngle, colorStops)
        : buildRadialGradientCssString(radialPosition, radialEndingShape, colorStops);

    return {
      previewBackground,
      sliderBackground,
    };
  }, [colorStops, model]);
}
